import { render } from "./TheTwoLineTitle.vue?vue&type=template&id=7122455e&scoped=true"
import script from "./TheTwoLineTitle.vue?vue&type=script&lang=js"
export * from "./TheTwoLineTitle.vue?vue&type=script&lang=js"

import "./TheTwoLineTitle.vue?vue&type=style&index=0&id=7122455e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7122455e"]])

export default __exports__